import {
  TableContainer,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  Box,
  Typography,
  Paper,
  Divider,
  Select,
  IconButton,
  Button,
  MenuItem,
  Menu,
  FormControl,
  Stack,
  Pagination,
  PaginationItem,
  Grid,
} from "@mui/material";
import { styled } from "@mui/material/styles";
import Switch from "@mui/material/Switch";
import EditButton from "../../../assets/icons/EditButton.svg";
import TrashButton from "../../../assets/icons/TrashButton.svg";
import ActiveAddButton from "../../../assets/icons/ActiveAddButton.svg";
import ArrowDown from "../../../assets/icons/ArrowDown.svg";
import React, { useState, useEffect } from "react";
import BackArrow from "../../../assets/icons/BackArrow.svg";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";
import CalanderActive from "../../../assets/icons/CalanderActive.svg";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";
import moment from "moment";
import { DateEditCalendar } from "../../CommonComponent/DateEditCalendar";
import CircularProgress from "@mui/material/CircularProgress";
import AddRolePermissionModel from "./AddRolePermissionModel";
import {
  getRolePermissionMasterList,
  deleteRolePermissionMasterList,
  updateRolePermissionMasterList,
} from "../../../redux/actions/mastersAction";
import EditRolePermissionModel from "./EditRolePermissionModel";
import noData from "../../../assets/images/Group 688.png";

const AntSwitch = styled(Switch)(({ theme }) => ({
  width: 28,
  height: 16,
  padding: 0,
  display: "flex",
  "&:active": {
    "& .MuiSwitch-thumb": {
      width: 15,
    },
    "& .MuiSwitch-switchBase.Mui-checked": {
      transform: "translateX(9px)",
    },
  },
  "& .MuiSwitch-switchBase": {
    padding: 2,
    "&.Mui-checked": {
      transform: "translateX(12px)",
      color: "#fff",
      "& + .MuiSwitch-track": {
        opacity: 1,
        backgroundColor: theme.palette.mode === "dark" ? "#26875C" : "#26875C",
      },
    },
  },
  "& .MuiSwitch-thumb": {
    boxShadow: "0 2px 4px 0 rgb(0 35 11 / 20%)",
    width: 12,
    height: 12,
    borderRadius: 6,
    transition: theme.transitions.create(["width"], {
      duration: 200,
    }),
  },
  "& .MuiSwitch-track": {
    borderRadius: 16 / 2,
    opacity: 1,
    backgroundColor:
      theme.palette.mode === "dark"
        ? "rgba(255,255,255,.35)"
        : "rgba(0,0,0,.25)",
    boxSizing: "border-box",
  },
}));

const RolePermissionMasterContent = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const jsonString = localStorage.getItem("roleMastersData");
  const roleMastersData = JSON.parse(jsonString);

  const isLoading = useSelector((state) => state?.user?.isLoading);

  // const companyData = useSelector((state) => state?.masters?.companyData);

  const rolePermissionMasterData = useSelector(
    (state) => state?.masters?.rolePermissionMasterData
  );

  const [RoleType, setRoleType] = useState(roleMastersData[0]?.id);
  const [isAddRolePermissionModel, setIsAddRolePermissionModel] =
    useState(false);
  const [isEditRolePermissionModel, setIsEditRolePermissionModel] =
    useState(false);
  // const [CompanyName, setCompanyName] = useState(companyData?.name);
  const [isPaginationLimit, setIsPaginationLimit] = useState("");

  const handleChangeIsPaginationLimit = (event) => {
    setIsPaginationLimit(event.target.value);
  };

  const handleChangeRoleType = (event) => {
    setRoleType(event.target.value);
  };

  const handleCloseAddRolePermissionModel = (e) => {
    setIsAddRolePermissionModel(false);
  };

  const handleCloseEditRolePermissionModel = (e) => {
    setIsEditRolePermissionModel(false);
  };

  // const handleChangeCompanyName = (event) => {
  //   setCompanyName(event.target.value);
  // };

  const handleDeleteRolePermission = (RolePermissionid) => {
    dispatch(
      deleteRolePermissionMasterList({
        id: RolePermissionid,
        role_id: RoleType,
      })
    );
  };

  useEffect(() => {
    dispatch(
      getRolePermissionMasterList({
        id: RoleType,
      })
    );
  }, [RoleType]);

  const toggleActiveStatus = (Screenrow) => {
    dispatch(
      updateRolePermissionMasterList({
        id: Screenrow?.id,
        active: !Screenrow?.active,
        role_id: RoleType
      })
    );
  };

  return (
    <>
      {isAddRolePermissionModel && (
        <AddRolePermissionModel
          isAddRolePermissionModel={isAddRolePermissionModel}
          handleCloseAddRolePermissionModel={handleCloseAddRolePermissionModel}
        />
      )}
      {isEditRolePermissionModel && (
        <EditRolePermissionModel
          isEditRolePermissionModel={isEditRolePermissionModel}
          handleCloseEditRolePermissionModel={
            handleCloseEditRolePermissionModel
          }
        />
      )}
      <Paper
        sx={{
          width: "auto",
          height: "auto",
          overflow: "auto",
          borderRadius: "10px",
        }}
      >
        <Box
          sx={{
            height: "80px",
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            gap: "20px",
            overflow: "auto",
            width: "auto",
            "&::-webkit-scrollbar": {
              width: "5px",
              height: "3px",
            },
            "&::-webkit-scrollbar-thumb": {
              backgroundColor: "#20724E",
              borderRadius: "4px",
            },
            "&::-webkit-scrollbar-track": {
              backgroundColor: "#E5F1EB",
            },
          }}
        >
          <Box sx={{ display: "flex" }}>
            <Box
              sx={{
                display: "flex",
                ml: 2,
                alignItems: "center",
                cursor: "pointer",
              }}
              onClick={() => {
                navigate("/masters");
              }}
            >
              <img src={BackArrow} alt="" width="17" height="17" />
            </Box>
            <Box>
              <Typography
                sx={{
                  ml: 1,
                  fontSize: "18px",
                  fontWeight: 600,
                  color: "#212121",
                  whiteSpace: "nowrap",
                  overflow: "hidden",
                  textOverflow: "ellipsis",
                }}
              >
                Role Permission Master
              </Typography>
            </Box>
          </Box>

          <Box sx={{ display: "flex" }}>
            <Box
              sx={{ display: "flex", alignItems: "center", gap: "10px", mr: 2 }}
            >
              {/* <Select
                value={CompanyName}
                onChange={handleChangeCompanyName}
                inputProps={{ "aria-label": "Without label" }}
                IconComponent={() => (
                  <Box
                    sx={{
                      marginRight: "10px",
                      display: "flex",
                      alignItems: "center",
                    }}
                  >
                    <img
                      src={ArrowDown}
                      alt="Custom Icon"
                      width="18"
                      height="24"
                    />
                  </Box>
                )}
                sx={{
                  height: "4vh",
                  width: "11rem",
                  color: "#20724E",
                  fontWeight: "bold",
                  borderRadius: "10px",
                  backgroundColor: "#E5F1EB",
                  mr: 2,
                  "& .css-1d3z3hw-MuiOutlinedInput-notchedOutline": {
                    border: "1px solid #E5F1EB",
                  },
                }}
              >
                <MenuItem value="" disabled>
                  {companyData?.name}
                </MenuItem>
              </Select> */}
              <Select
                value={RoleType}
                onChange={handleChangeRoleType}
                displayEmpty
                inputProps={{ "aria-label": "Without label" }}
                IconComponent={() => (
                  <Box
                    sx={{
                      marginRight: "10px",
                      display: "flex",
                      alignItems: "center",
                    }}
                  >
                    <img
                      src={ArrowDown}
                      alt="Custom Icon"
                      width="18"
                      height="24"
                    />
                  </Box>
                )}
                sx={{
                  height: "37px",
                  width: "11rem",
                  color: "#20724E",
                  fontWeight: "bold",
                  borderRadius: "10px",
                  backgroundColor: "#E5F1EB",
                  mr: 2,
                  border: "none",
                  "& .css-1d3z3hw-MuiOutlinedInput-notchedOutline": {
                    border: "1px solid #E5F1EB",
                  },
                  "& .MuiOutlinedInput-notchedOutline": {
                    border: "none",
                  },
                }}
                InputLabelProps={{
                  shrink: true,
                }}
              >
                <MenuItem value="" disabled>
                  Role Type
                </MenuItem>
                {roleMastersData.map((row) => (
                  <MenuItem value={row.id}>{row.name}</MenuItem>
                ))}
              </Select>

              {/* <Button
                variant="outlined"
                sx={{
                  fontSize: "15px",
                  fontWeight: 600,
                  borderColor: "#26875C",
                  width: "6rem",
                  backgroundColor: "FFFFFF",
                  padding: "6px 0px 4px 0px",
                  borderRadius: "10px",
                  textTransform: "capitalize",
                  color: "#26875C",
                  ":hover": {
                    borderColor: "#26875C",
                  },
                }}
                onClick={() => setIsAddRolePermissionModel(true)}
              >
                <Box sx={{ marginRight: "10px" }}>
                  <img src={ActiveAddButton} alt="" />
                </Box>
                Add
              </Button> */}
            </Box>
          </Box>
        </Box>
        <Divider sx={{ width: "auto" }} />

        <Box sx={{ margin: "10px 25px 20px 25px" }}>
          <TableContainer
            sx={{
              maxHeight: "620px",
              "&::-webkit-scrollbar": {
                width: "5px",
                height: "3px",
              },
              "&::-webkit-scrollbar-thumb": {
                backgroundColor: "#20724E",
                borderRadius: "4px",
              },
              "&::-webkit-scrollbar-track": {
                backgroundColor: "#E5F1EB",
              },
            }}
          >
            {rolePermissionMasterData.length <= 0 ? (
              <Grid sx={{ paddingTop: "20px" }}>
                <Grid
                  item
                  sx={{
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                    justifyContent: "center",
                  }}
                >
                  <Box>
                    <Box
                      component="img"
                      sx={{
                        height: "25rem",
                        width: "auto",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                      }}
                      alt=""
                      src={noData}
                    />
                  </Box>
                  <Box
                    fontWeight="600"
                    sx={{ padding: "20px", fontWeight: "600" }}
                  >
                    <Typography sx={{ fontWeight: "600", fontSize: "18px" }}>
                      No Data Found
                    </Typography>
                  </Box>
                </Grid>
              </Grid>
            ) : (
              <Table stickyHeader>
                <TableHead>
                  <TableRow>
                    <TableCell
                      sx={{
                        color: "#B5B5C3",
                        fontWeight: 600,
                        textAlign: "left",
                        whiteSpace: "nowrap",
                      }}
                    >
                      Screens
                    </TableCell>
                    {/* <TableCell
                      sx={{
                        color: "#B5B5C3",
                        fontWeight: 600,
                        textAlign: "right",
                        whiteSpace: "nowrap",
                      }}
                    >
                      Action
                    </TableCell> */}
                    <TableCell
                      sx={{
                        color: "#B5B5C3",
                        fontWeight: 600,
                        whiteSpace: "nowrap",
                      }}
                    >
                      Active
                    </TableCell>
                    <TableCell></TableCell>
                  </TableRow>
                </TableHead>
                {isLoading ? (
                  <TableBody>
                    <TableRow
                      sx={{
                        "&:last-child td, &:last-child th": { border: 0 },
                        height: "10rem",
                      }}
                    >
                      <TableCell colSpan={8} align="center">
                        <CircularProgress color="success" />
                      </TableCell>
                    </TableRow>
                  </TableBody>
                ) : (
                  <TableBody>
                    {rolePermissionMasterData.map((row, index) => (
                      <TableRow
                        // key={row.Checklist}
                        sx={{
                          "&:last-child td, &:last-child th": { border: 0 },
                        }}
                      >
                        <TableCell
                          sx={{
                            color: "#464E5F",
                            textAlign: "left",
                            whiteSpace: "nowrap",
                          }}
                        >
                          {row?.screen?.name}
                        </TableCell>
                        {/* <TableCell sx={{ textAlign: "right" }}>
                          <IconButton
                            onClick={() => handleDeleteRolePermission(row?.id)}
                          >
                            <img src={TrashButton} width="30" height="30" />
                          </IconButton>
                        </TableCell> */}

                        <TableCell sx={{
                          color: "#464E5F", fontWeight: "600"
                        }}>
                          <Box onClick={() => toggleActiveStatus(row)}>
                            <AntSwitch checked={row.active} color="primary" />
                          </Box>
                        </TableCell>
                        <TableCell></TableCell>
                      </TableRow>
                    ))}
                  </TableBody>
                )}
              </Table>
            )}
          </TableContainer>
          <Divider />
          {/* {rolePermissionMasterData.length > 0 && (
            <Stack
              spacing={2}
              direction="row"
              justifyContent="flex-end"
              alignItems="center"
              sx={{
                padding: "1rem",
                marginTop: "10px",
              }}
            >
              <Box
                sx={{
                  display: "flex",
                  alignItems: "center",
                }}
              >
                <Typography sx={{ mr: "8px" }}>Row Per Page</Typography>
                <Select
                  value={isPaginationLimit}
                  onChange={handleChangeIsPaginationLimit}
                  displayEmpty
                  inputProps={{ "aria-label": "Without label" }}
                  IconComponent={() => (
                    <Box
                      sx={{
                        marginRight: "10px",
                        display: "flex",
                        alignItems: "center",
                      }}
                    >
                      <img
                        src={ArrowDown}
                        alt="Custom Icon"
                        width="18"
                        height="24"
                      />
                    </Box>
                  )}
                  sx={{
                    height: "37px",
                    width: "6rem",
                    color: "#20724E",
                    fontWeight: "bold",
                    borderRadius: "10px",
                    border: "none",
                    backgroundColor: "#E5F1EB",
                    mr: 2,
                    "& .css-1d3z3hw-MuiOutlinedInput-notchedOutline": {
                      border: "1px solid #E5F1EB",
                    },
                    "& .MuiOutlinedInput-notchedOutline": {
                      border: "none",
                    },
                  }}
                  InputLabelProps={{
                    shrink: true,
                  }}
                >
                  <MenuItem value="">10</MenuItem>
                  <MenuItem value={10}>20</MenuItem>
                  <MenuItem value={20}>30</MenuItem>
                </Select>
              </Box>
              <Box>
                <Pagination
                  count={10}
                  renderItem={(item) => (
                    <PaginationItem
                      slots={{
                        previous: ArrowBackIcon,
                        next: ArrowForwardIcon,
                      }}
                      {...item}
                    />
                  )}
                />
              </Box>
            </Stack>
          )} */}
        </Box>
      </Paper>
    </>
  );
};

export default RolePermissionMasterContent;
